import { Controller } from '@hotwired/stimulus';

const CLASS_HIDDEN = 'd-none';

/**
 * Allow searching through groups of organisations, matching either:
 * - The group name, where the whole group is visible
 * - Individual orgs, where just the matching orgs & group header will show
 */
export default class extends Controller {
  static targets = ['group'];

  filter({ target: { value } }) {
    this.query = this.#normalizeText(value);

    this.groupTargets.forEach((group) => {
      const groupName = this.#normalizeText(group.dataset.groupName);
      const orgElements = group.querySelectorAll(
        '[data-organisation-search-target="organisation"]'
      );

      if (groupName && groupName.includes(this.query)) {
        orgElements.forEach((org) => org.classList.remove(CLASS_HIDDEN));
        group.classList.remove(CLASS_HIDDEN);
      } else {
        let anyVisible = false;
        orgElements.forEach((org) => {
          const match = this.#normalizeText(
            org.dataset.organisationName
          ).includes(this.query);
          org.classList.toggle(CLASS_HIDDEN, !match);

          if (match) anyVisible = true;
        });
        group.classList.toggle(CLASS_HIDDEN, !anyVisible);
      }
    });
  }

  #normalizeText(text) {
    return text?.toLowerCase().replace(/['-]/g, '').replace(/\s+/g, ' ').trim();
  }
}
